import { render, staticRenderFns } from "./ContactCustomAttributes.vue?vue&type=template&id=7a071c2d&scoped=true&"
import script from "./ContactCustomAttributes.vue?vue&type=script&lang=js&"
export * from "./ContactCustomAttributes.vue?vue&type=script&lang=js&"
import style0 from "./ContactCustomAttributes.vue?vue&type=style&index=0&id=7a071c2d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a071c2d",
  null
  
)

export default component.exports